module.exports = __webpack_public_path__ + "static/media/upright_2door.1719acca.png";